import { Router } from '@angular/router';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { LocalService, StoreService } from '../../core';
import { CONSTANTS } from '../../config';
import { CanComponentDeactivate } from '../../core/services/create-promo-saved.guard';

@Component({
  selector: 'app-manage-activities',
  templateUrl: './manage-activities.component.html',
  styleUrls: ['./manage-activities.component.scss'],
})
export class ManageActivitiesComponent
  implements OnInit, AfterViewInit, CanComponentDeactivate {
  userProfile: any;
  pamData: any = '';
  isCiscoAdmin = false;
  isAdminUser: Boolean = false;
  isSalesManager: Boolean = false;
  isPracticeLead: Boolean = false;
  pviEligible = false;
  practiceLeadUser = CONSTANTS.practiceLead;
  salesManagerUser = CONSTANTS.salesManager;
  adminUser = CONSTANTS.admin;

  selectedTab = 'sales'; // default selected tab
  tabs: any[] = [];

  isPromoCreationSuccess = false;
  confirmLeaveModalOpen = false;
  private confirmLeaveResolver: ((value: boolean) => void) | null = null;
  private pendingPromoAction: (() => void) | null = null;

  constructor(
    private storeService: StoreService,
    private router: Router
  ) { }

  ngOnInit() {
    this.userProfile = LocalService.get('userProfile');
    if (
      this.userProfile.pvieligible === false ||
      (this.userProfile.companyEligibleChallengesDTO &&
        this.userProfile.companyEligibleChallengesDTO.pvieligible === false)
    ) {
      this.pviEligible = true;
    }
    if (
      this.userProfile.hasOwnProperty('userType') &&
      this.userProfile.userType === 'PAM'
    ) {
      this.pamData = LocalService.get('pamData');
      if (!this.pamData) {
        this.pamData = this.userProfile.pamDefaultSelection;
      }
      const pamBeGeoIds = this.pamData.pamBeGeoIdsDTO
        ? this.pamData.pamBeGeoIdsDTO.beGeoIds
        : this.pamData.beGeoIds;
      if (
        pamBeGeoIds &&
        pamBeGeoIds.length > 0 &&
        pamBeGeoIds[0].companyEligibleChallengesDTO &&
        pamBeGeoIds[0].companyEligibleChallengesDTO.pvieligible === false
      ) {
        this.pviEligible = true;
      }
    }

    // Resolve isCiscoAdmin from localStorage before any API calls so all
    // downstream calls (buildTabs, etc.) use the right value.
    if (this.userProfile.roles.find((item: any) => item.name === 'CISCO_ADMIN')) {
      if (
        this.router.url === '/home/manager/manage-challenges' &&
        this.userProfile.createSalesChg
      ) {
        this.isCiscoAdmin = true;
      }
    }

    this.checkRoles();
    this.buildTabs();

    if (this.selectedTab === 'sales' && (this.isAdminUser || this.isPracticeLead || this.isSalesManager)) {
      this.setTab('sales');
    }
    this.storeService.getIsciscoAdminFlag().subscribe((data: any) => {
      if (data != null) {
        if (data.isCiscoAdmin === true) {
          this.isCiscoAdmin = true;
          this.selectedTab = 'sales';
        } else {
          this.isCiscoAdmin = false;
          if (this.isAdminUser || this.isPracticeLead || this.isSalesManager) {
            this.setTab('sales');
          }
        }
        setTimeout(() => {
          this.buildTabs();
        });
      }
    });
  }

  ngAfterViewInit() {
    window.scrollTo(0, 0);
  }

  buildTabs() {
    this.tabs = [
      // Sales challenge tab
      // non-cisco: visible when !isCiscoAdmin
      // cisco admin: uses resetSalesChallenges (view sales)
      {
        id: 'sales',
        label: 'manageActivity.salesChallenges',
        iconHtml: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <line x1="12" x2="12" y1="2" y2="22"></line>
                  <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                </svg>`,
        isVisible: this.isCiscoAdmin
          ? true  // cisco admin always sees this (view sales challenge)
          : !!(this.isAdminUser || this.isPracticeLead || this.isSalesManager)
      },
      // Activity challenge tab
      // visible for roles + sales manager only + cisco admin
      {
        id: 'activity',
        label: 'manageActivity.defaultTab',
        iconHtml: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                  viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0
                  l-2.35 8.36A2 2 0 0 1 4.49 12H2"/>
                </svg>`,
        isVisible: true  // always visible based on parent *ngIf guard
      },
      // Leaderboard tab
      // non-cisco: APJ region only
      // cisco admin: always visible
      {
        id: 'leaderboard',
        label: 'manageActivity.leaderBoardChallenge',
        iconHtml: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-dollar-sign h-4 w-4">
              <line x1="12" x2="12" y1="2" y2="22"></line>
              <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
            </svg>`,
        isVisible: this.isCiscoAdmin
          ? true
          : this.userProfile.company.region === 'APJ'
      }
    ];
  }

  onTabChange(id: string) {
    switch (id) {
      case 'sales':
        this.isCiscoAdmin ? this.resetSalesChallenges() : this.setTab('sales');
        break;
      case 'activity':
        this.setTab('activity');
        break;
      case 'leaderboard':
        this.setTab('leaderboard');
        break;
    }
  }

  checkRoles() {
    this.isAdminUser = this.userProfile.hasOwnProperty('userType')
      ? true
      : this.userProfile.roles.filter((item: any) =>
        this.adminUser.includes(item.name)
      ).length;
    this.isSalesManager = this.userProfile.hasOwnProperty('userType')
      ? true
      : this.userProfile.roles.find(
        (item: any) => item.name === this.salesManagerUser
      );
    this.isPracticeLead = this.userProfile.hasOwnProperty('userType')
      ? true
      : this.userProfile.roles.find(
        (item: any) => item.name === this.practiceLeadUser
      );
  }

  setTab(tabId: string) {
    if (this.selectedTab === tabId) {
      return;
    }
    if (this.selectedTab === 'promotions' && !this.isPromoCreationSuccess) {
      this.pendingPromoAction = () => { this.selectedTab = tabId; };
      this.confirmLeaveModalOpen = true;
    } else {
      this.selectedTab = tabId;
    }
  }

  goToSalesTab() {
    this.selectedTab = 'sales';
  }

  resetSalesChallenges() {
    if (this.selectedTab === 'promotions' && !this.isPromoCreationSuccess) {
      this.pendingPromoAction = () => this.goToSalesTab();
      this.confirmLeaveModalOpen = true;
    } else {
      this.goToSalesTab();
    }
  }

  showActivityTab() {
    this.setTab('activity');
  }

  onNavigateToPromotions() {
    this.selectedTab = 'promotions';
  }

  async canDeactivatePage(): Promise<any> {
    if (this.selectedTab !== 'promotions') { return true; }
    return this.openConfirmDialog();
  }

  openConfirmDialog(): Promise<boolean> {
    this.confirmLeaveModalOpen = true;
    return new Promise((resolve) => {
      this.confirmLeaveResolver = resolve;
    });
  }

  onConfirmLeave(flag: boolean) {
    this.confirmLeaveModalOpen = false;
    if (this.confirmLeaveResolver) {
      this.confirmLeaveResolver(flag);
      this.confirmLeaveResolver = null;
    }
    if (flag && this.pendingPromoAction) {
      const action = this.pendingPromoAction;
      this.pendingPromoAction = null;
      action();
    }
  }
}
